import { Subject } from "rxjs";
export const snakbar = new Subject();
export const DialogOpen = new Subject();
export const DialogClose = new Subject();

export const drawerOpen = new Subject();
export const drawerClose = new Subject();
